<script lang="ts">
  import DashboardNumberBlock from "@kontextwerk/web-sdk/ui/analytics/sessions/components/charts/DashboardNumberBlock.svelte"
  import type { CostBenefitEstimate } from "../../../../../api/kehrblatt/cost-benefit"
  import { buildCostBenefitNumberCards } from "./_logic/presentation"

  let {
    estimate = null,
    loading = false,
    error = null,
    darkMode = true,
  }: {
    estimate?: CostBenefitEstimate | null
    loading?: boolean
    error?: string | null
    darkMode?: boolean
  } = $props()

  const totalsCards = $derived(buildCostBenefitNumberCards({ estimate, loading, error }))
</script>

<div class:light={!darkMode} class="cost-benefit-numbers">
  <DashboardNumberBlock {totalsCards} />
</div>

<style lang="less">
  .cost-benefit-numbers {
    margin-top: -0.3rem;
  }

  .cost-benefit-numbers :global(.totals-grid) {
    margin-top: 0;
  }

  .cost-benefit-numbers :global(.totals-card) {
    min-width: 0;
  }

  .cost-benefit-numbers :global(.totals-card__value) {
    white-space: normal;
    text-align: right;
    line-height: 1.15;
  }

  .cost-benefit-numbers.light :global(.totals-card) {
    background: var(--bg-invers-100, #ffffff);
    border-color: color-mix(in srgb, var(--text-invers-100, #1f2937) 12%, transparent);
  }

  .cost-benefit-numbers.light :global(.totals-card__label) {
    color: color-mix(in srgb, var(--text-invers-100, #1f2937) 78%, transparent) !important;
  }

  .cost-benefit-numbers.light :global(.totals-card__value) {
    color: var(--text-invers-100, #1f2937) !important;
  }

  .cost-benefit-numbers.light :global(.totals-card__info) {
    color: color-mix(in srgb, var(--text-invers-100, #1f2937) 62%, transparent);
  }

  .cost-benefit-numbers.light :global(.totals-card__info:hover),
  .cost-benefit-numbers.light :global(.totals-card__info:focus-visible) {
    color: var(--text-invers-100, #1f2937);
  }
</style>
